import { AufnahmePunktDocument } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

export const maechtigkeitEval: EvalFunc = (bp: any, i?: number, key?: string, tiefeOverride?: number, atEnd?: boolean) => {
    const b = bp as AufnahmePunktDocument;
    if (i === undefined) return;
    switch (key) {
			case 'SMächtigkeit': {
				const t = tiefeOverride ?? b.Substratfolge[i].tiefe;
				return i == 0 && !atEnd
						? t
						: t - b.Substratfolge[atEnd ? i : i - 1].tiefe;
			}
      case 'HMächtigkeit': {
				// Eine Horizontzeile darf ohne Tiefe bestehen (angelegt, noch nicht
				// gefuellt). Fehlt eine der beiden Tiefen, bleibt das Ergebnis wie
				// bisher „keine Zahl" (NaN) - so hat JavaScript mit der fehlenden
				// Tiefe schon immer gerechnet, nur sagte es der Typ nicht.
				// ⚠ Bewusst NICHT undefined: Das Eingabefeld uebernimmt jedes Ergebnis
				// ausser undefined; bei undefined bliebe die alte, nicht mehr passende
				// Maechtigkeit im Feld stehen. Festgehalten in maechtigkeit.spec.ts.
				const t = tiefeOverride ?? b.Horizontfolge[i].tiefe;
				if (i == 0 && !atEnd) return t;
				const vorher = b.Horizontfolge[atEnd ? i : i - 1].tiefe;
				return (t ?? NaN) - (vorher ?? NaN);
			}
      default: return;
    }
};
